import {Button, Flex, Icon} from '@priority-software/priority-style-react';
import React, {FC, useCallback, useEffect} from 'react';
import styles from '../../styles.module.scss';
import {TVoidFunction} from '../../../types';
import {TIconType} from '../types';
import {IconWithPopover} from '../../IconWithPopover';
import {icons} from '../../../utils/getIcons';
import {createDataTestId} from '../../../../../utils/dataTestId';
import {typeComponents} from '../constants';
import {useEmailContext} from '../../../context';

interface SideBarIconsProp {
    setActiveComponent: TVoidFunction<TIconType>;
    activeComponent: TIconType;
}

export const SideBarIcons: FC<SideBarIconsProp> = ({setActiveComponent, activeComponent}) => {
    const {
        states: {focusSubject}
    } = useEmailContext();

    const activeButton = useCallback(
        (type: TIconType) => type === activeComponent,
        [activeComponent]
    );

    const isDisabled = checkDisabled(focusSubject);

    useEffect(() => {
        if (focusSubject && !activeButton(typeComponents.PERSONALIZE)) {
            setActiveComponent(typeComponents.PERSONALIZE);
        }
    }, [focusSubject]);

    return (
        <Flex direction="column" componentClasses={styles.gap}>
            {icons.map(({iconName, id, type, content}) => {
                const disabled = isDisabled(type);

                return (
                    <IconWithPopover type="children" key={id} content={content}>
                        <Button
                            {...createDataTestId(`email-side-bar-icon-${type}`, true)}
                            disabled={disabled}
                            active={activeButton(type)}
                            key={id}
                            onClick={() => setActiveComponent(type)}
                            skin="secondary"
                            size="large"
                            icon={
                                <Icon
                                    icon={iconName}
                                    {...(disabled && {iconColor: 'secondary-300'})}
                                />
                            }
                            style={{
                                ...(disabled && {backgroundColor: '#FFFFFF'})
                            }}
                        />
                    </IconWithPopover>
                );
            })}
        </Flex>
    );
};

const checkDisabled = (focusSubject: boolean) => (type: TIconType) =>
    type !== typeComponents.PERSONALIZE && focusSubject;
